// src/utils/championshipState.js
export const CHAMPIONSHIP_STATE = {
  0: {
    label: "Oculto",
    className: "bg-slate-100 text-slate-600 ring-slate-200",
  },
  1: {
    label: "Por iniciar",
    className: "bg-sky-50 text-sky-700 ring-sky-200",
  },
  2: {
    label: "En curso",
    className: "bg-red-50 text-red-700 ring-red-200",
  },
  3: {
    label: "Finalizado",
    className: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  },
};

export function getChampionshipStateMeta(state) {
  return CHAMPIONSHIP_STATE[Number(state)] || CHAMPIONSHIP_STATE[1];
}
